export default __webpack_public_path__ + "static/media/gallery-wip-emitter_03.c1268064.jpg";